var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4405_8776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.75 37.5C68.75 42.4728 66.7746 47.2419 63.2583 50.7583C59.7419 54.2746 54.9728 56.25 50 56.25C45.0272 56.25 40.2581 54.2746 36.7417 50.7583C33.2254 47.2419 31.25 42.4728 31.25 37.5C31.25 32.5272 33.2254 27.7581 36.7417 24.2417C40.2581 20.7254 45.0272 18.75 50 18.75C54.9728 18.75 59.7419 20.7254 63.2583 24.2417C66.7746 27.7581 68.75 32.5272 68.75 37.5Z",
    fill: "#535775"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 50C0 36.7392 5.26784 24.0215 14.6447 14.6447C24.0215 5.26784 36.7392 0 50 0C63.2608 0 75.9785 5.26784 85.3553 14.6447C94.7322 24.0215 100 36.7392 100 50C100 63.2608 94.7322 75.9785 85.3553 85.3553C75.9785 94.7322 63.2608 100 50 100C36.7392 100 24.0215 94.7322 14.6447 85.3553C5.26784 75.9785 0 63.2608 0 50ZM50 6.25C41.7611 6.25044 33.6898 8.57727 26.715 12.9627C19.7402 17.3481 14.1455 23.6138 10.5748 31.0387C7.00403 38.4636 5.60242 46.7459 6.53124 54.9322C7.46006 63.1186 10.6816 70.8763 15.825 77.3125C20.2625 70.1625 30.0312 62.5 50 62.5C69.9688 62.5 79.7313 70.1562 84.175 77.3125C89.3184 70.8763 92.5399 63.1186 93.4688 54.9322C94.3976 46.7459 92.996 38.4636 89.4252 31.0387C85.8545 23.6138 80.2598 17.3481 73.285 12.9627C66.3102 8.57727 58.2389 6.25044 50 6.25Z",
    fill: "#535775"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4405_8776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bcecc7730bceed0b5a1a6078e2a9679e.svg";
export { ForwardRef as ReactComponent };